import Vue from 'vue'
import App from './App.vue'
import router from './router'
import crypto from 'crypto'
import settings from "./backend/LocalSettings";
import moment from "moment";
import VueResource from "vue-resource";
import locale from "element-ui/lib/locale/lang/ro"
import VueSignaturePad from "vue-signature-pad"
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import BootstrapVue from 'bootstrap-vue'
import numeral from 'numeral'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueResource);
Vue.use(ElementUI, { locale });
Vue.use(VueSignaturePad);
Vue.http.options.xhr = { withCredentials: true };
Vue.http.options.emulateJSON = true;
Vue.http.headers.common["Token"] = settings.get_token();

Vue.http.options.root = settings.BASE_URL;
// Vue.http.options.root = "https://service.anvelopeinstoc.ro/api/index.php";
Vue.mixin({
  created: function () {
    // this.hello()
  },
  methods: {
    // hello: function () {
    // console.log('hello from mixin!')
    // }
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
});

Vue.filter( 'formatSecundeMinuteOre', function(value){

  if (value < 1) return "-";

  let result= moment().startOf('day').seconds(value);

  let final = '';
  if (parseInt(result.format('H')) > 0) final  += parseInt(result.format('H')) + ' ore';
  if (parseInt(result.format('mm')) > 0) final += ' ' + parseInt(result.format('mm')) + ' min';
  if (parseInt(result.format('ss')) > 0) final += ' ' + parseInt(result.format('ss')) + ' sec';



  return final.trim();
  
} );

Vue.filter('Frumos', function (value) {


  // daca nu e null, inlocuieste _ cu spatiu si face prima litera uppercase

  if (value !== null) {
    return value.replace(/_/g, ' ').replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
  } else {
    return "-"
  }
  // sa fie propercase si _ inlocuit cu spatii
  // prima litera din fiecare cuvant sa fie uppercase
  
});

Vue.filter( 'DaNu', function(value){
  if (Number(value) == '0') return 'Nu'
  else return "Da"
} );

Vue.filter( 'momentformat', function(value){
  return value;
} );

Vue.filter( 'DataRo', function(value){
  let formatata = moment(value);
  if (formatata.isValid()) return formatata.format("DD.MM.YYYY");
  else return "-";
} );

Vue.filter( 'DataOra', function(value){
  let formatata = moment(value);
  if (formatata.isValid()) return formatata.format("DD.MM.YYYY HH:mm:ss");
  else return "-";
} );

Vue.filter( 'DataOraFaraSec', function(value){
  let formatata = moment(value);
  if (formatata.isValid()) return formatata.format("DD.MM.YYYY HH:mm")
  else return "-";
} );

Vue.filter( 'OraFaraSec', function(value){
  let formatata = moment(value);
  if (formatata.isValid()) return formatata.format("HH:mm")
  else return "-";
} );

Vue.filter('format_money', function (value) {
  if (value !== undefined) {
      var nr = parseFloat(value)
      return numeral(nr).format('0,0.00')
  } else {
      return null
  }
  })

Vue.prototype.$has_right = function (rightKey)
{
    var ret             = false;
  var drepturiDecoded = settings.get_drepturi();
    var numarUnic       = (drepturiDecoded.length - 1) * (458 + 73 - 23)
    var caractereUnice  = 'nimic' + numarUnic
    var verificareCrc   = crypto.createHash('md5').update(Buffer.from(caractereUnice)).digest('hex')
    if (drepturiDecoded.indexOf(verificareCrc) !== -1)
    {
        var indexDrept = drepturiDecoded.indexOf(rightKey)
    if (indexDrept !== -1) ret = true;
  }
  return ret;
}

new Vue({
  router,
    render: h => h(App)
}).$mount('#app')
